import { Component } from '@angular/core';

import { CkEditorConfigService } from '@app/services/ckeditor-config.service';
import { ThemeService } from '@app/services/theme.service';
import { NavigationService } from '@app/services/navigation.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  public selectedTheme: string;

  constructor(
    private _navigationService: NavigationService,
    private themeService: ThemeService,
    private _ckeditorConfigService: CkEditorConfigService
  ) {
    this.selectedTheme = themeService.selectedTheme;
    // console.log('Selected Theme:', this.selectedTheme);

    this._navigationService.startSaveHistory();

    // Runs in the constructor so listeners are installed before router-outlet activates
    // any route and any editor can mount. See CkEditorConfigService for full details.
    this._ckeditorConfigService.configureCkeditor4();
  }

  ngOnInit() {
    this.themeService.listenForThemeChange().subscribe(_updatedTheme => this.selectedTheme = _updatedTheme);
  }
}